// components/profesionales/Insignias/Insignias.js
import React, { useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import Spinner from 'react-bootstrap/Spinner'
import { toast } from 'react-toastify'
import api from 'api/api'
import './Insignias.css'

function Insignias(props) {
	const { insignias, profesionalId, onInsigniaUpdated } = props
	const [loading, setLoading] = useState({})

	if (!insignias || insignias.length === 0) {
		return (
			<Alert variant="info">El profesional no tiene insignias registradas</Alert>
		)
	}

	// Función para obtener el estado de la insignia
	const getEstadoInsignia = (insignia) => {
		const habilitada = insignia.habilitada
		const enUso = insignia.enUso

		if (habilitada === true || habilitada === 1) {
			if (enUso === true || enUso === 1) {
				return {
					estado: 'habilitada-en-uso',
					badge: <Badge bg="success">Verificada y en uso</Badge>,
					opacity: 1
				}
			} else {
				return {
					estado: 'habilitada-sin-uso',
					badge: <Badge bg="info">Verificada - No visible</Badge>,
					opacity: 0.6
				}
			}
		} else if (habilitada === false || habilitada === 0) {
			return {
				estado: 'deshabilitada',
				badge: <Badge bg="danger">Deshabilitada</Badge>,
				opacity: 0.4
			}
		} else { // habilitada === null
			if (enUso === true || enUso === 1) {
				return {
					estado: 'pendiente-verificacion',
					badge: <Badge bg="warning" text="dark">Pendiente de verificación</Badge>,
					opacity: 1
				}
			} else {
				return {
					estado: 'sin-verificar',
					badge: <Badge bg="secondary">Sin verificar</Badge>,
					opacity: 0.6
				}
			}
		}
	}

	// Función para manejar la habilitación/deshabilitación
	const handleToggleHabilitacion = async (insignia, nuevoEstado) => {
		if (!profesionalId) {
			toast.error('ID de profesional no disponible')
			return
		}

		setLoading(prev => ({ ...prev, [insignia.id]: true }))

		try {
			const { msg, error } = await api.post(`a/profesionales/${profesionalId}/insignias`, {
				insigniaId: insignia.id,
				habilitada: nuevoEstado
			})

			if (error) {
				toast.error('Error al actualizar insignia: ' + error)
				return
			}

			toast.success(msg || `Insignia ${nuevoEstado ? 'habilitada' : 'deshabilitada'} correctamente`)

			// Llamar callback para actualizar los datos si está disponible
			if (onInsigniaUpdated) {
				onInsigniaUpdated()
			}
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(prev => ({ ...prev, [insignia.id]: false }))
		}
	}

	// Función para determinar qué botón mostrar
	const renderBotonAccion = (insignia) => {
		const habilitada = insignia.habilitada
		const isLoading = loading[insignia.id]

		if (isLoading) {
			return (
				<Button variant="outline-secondary" size="sm" disabled>
					<Spinner size="sm" animation="border" />
				</Button>
			)
		}

		if (habilitada === true || habilitada === 1) {
			// Está habilitada, mostrar botón para deshabilitar
			return (
				<Button
					variant="outline-danger"
					size="sm"
					onClick={() => handleToggleHabilitacion(insignia, false)}
				>
					<i className="fa fa-times me-1"></i>
					Deshabilitar
				</Button>
			)
		} else {
			// Está deshabilitada o sin verificar, mostrar botón para habilitar
			return (
				<Button
					variant="outline-success"
					size="sm"
					onClick={() => handleToggleHabilitacion(insignia, true)}
				>
					<i className="fa fa-check me-1"></i>
					Habilitar
				</Button>
			)
		}
	}

	return (
		<Container fluid className="insignias-container">
			<Row>
				{insignias.map((insignia) => {
					const estadoInfo = getEstadoInsignia(insignia)

					return (
						<Col key={insignia.id} xs={12} md={6} lg={4} className="mb-3">
							<Card
								className="insignia-card"
								style={{ opacity: estadoInfo.opacity }}
							>
								<Card.Body>
									<div className="insignia-icon">
										<i className={`fa fa-award ${estadoInfo.estado === 'habilitada-en-uso' ? 'text-success' : 'text-secondary'}`}></i>
									</div>
									<h5 className="insignia-nombre">{insignia.nombre}</h5>
									<div className="insignia-estado mb-3">
										{estadoInfo.badge}
									</div>
									{insignia.label && (
										<p className="insignia-descripcion">{insignia.label}</p>
									)}
									{insignia.descripcion && (
										<p className="insignia-descripcion">{insignia.descripcion}</p>
									)}
									<div className="text-center mt-3">
										{renderBotonAccion(insignia)}
									</div>
								</Card.Body>
							</Card>
						</Col>
					)
				})}
			</Row>
		</Container>
	)
}

export default Insignias